var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("text-area-row", {
        attrs: {
          title: "AidApplication.Operation.PlaceOpen.HardlyEmployedDescription",
          id: "hardlyemployeddescription",
          required: true,
          maxLength: 1000,
          rows: 10
        },
        model: {
          value: _vm.information.hardlyEmployedDescription,
          callback: function($$v) {
            _vm.$set(_vm.information, "hardlyEmployedDescription", $$v)
          },
          expression: "information.hardlyEmployedDescription"
        }
      }),
      _vm._v(" "),
      _c("text-area-row", {
        attrs: {
          title:
            "AidApplication.Operation.PlaceOpen.NonProfitAspectDescription",
          id: "nonprofitaspectdescription",
          required: true,
          maxLength: 1000,
          rows: 10
        },
        model: {
          value: _vm.information.nonProfitAspectDescription,
          callback: function($$v) {
            _vm.$set(_vm.information, "nonProfitAspectDescription", $$v)
          },
          expression: "information.nonProfitAspectDescription"
        }
      }),
      _vm._v(" "),
      _c("radio-button-row", {
        attrs: {
          title: "AidApplication.Operation.PlaceOpen.AdditionalCostsRequired",
          required: true
        },
        model: {
          value: _vm.information.additionalCostsRequired,
          callback: function($$v) {
            _vm.$set(_vm.information, "additionalCostsRequired", $$v)
          },
          expression: "information.additionalCostsRequired"
        }
      }),
      _vm._v(" "),
      _c("text-area-row", {
        attrs: {
          title: "AidApplication.Operation.PlaceOpen.MentoringDescription",
          id: "mentoringdescription",
          required: true,
          maxLength: 1000,
          rows: 10
        },
        model: {
          value: _vm.information.mentoringDescription,
          callback: function($$v) {
            _vm.$set(_vm.information, "mentoringDescription", $$v)
          },
          expression: "information.mentoringDescription"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }